import React from "react";
import "./CorporateSocial.css";

const CorporateSocial = () => {
  return (
    <div>
      <h1>
        Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ad, modi.
      </h1>
    </div>
  );
};

export default CorporateSocial;
